import React, { useState, useEffect, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
	getOrganizations,
	getParsedToken,
} from '../../firebaseActions.mjs';
import { storeSetOrganizations } from '../../actions/OrganizationsActions'
import OrganizationSettingsModal from '../pages/Profile/OrganizationSettingsModal.jsx';

const MIN_ORGS_TO_SHOW_SEARCH = 10;

function OrganizationsDropdown({ user, value, setValue, isSidebar }) {
	const dispatch = useDispatch();
	const [selectedOrganization, setSelectedOrganization] = useState(value ? value : null)
	const { organizations } = useSelector((state) => state.organizations);
	const [organizationModal, setOrganizationModal] = useState(null);
	const [searchTerm, setSearchTerm] = useState('');

	const sortedOrganizations = useMemo(() => {
		return [...organizations].sort((a, b) => a.data.name.localeCompare(b.data.name))
	}, [organizations]);

	const filteredOrganizations = useMemo(() => {
		if (!searchTerm) return sortedOrganizations;
		const term = searchTerm.toLowerCase();
		return sortedOrganizations.filter((organization) => organization.data.name.toLowerCase().includes(term));
	}, [sortedOrganizations, searchTerm]);

	const showOrgsSearch = organizations.length > MIN_ORGS_TO_SHOW_SEARCH;

	let hideHome = getParsedToken()?.hideHome;

	useEffect(() => {
		if (hideHome && !selectedOrganization && sortedOrganizations?.length) {
			setSelectedOrganization(sortedOrganizations[0]);
		}
	}, [hideHome, selectedOrganization, sortedOrganizations]);

	const dropdownDisplayLabel = () => {
		if (!selectedOrganization) return 'Home'
		return selectedOrganization.data.name
	}
	useEffect(() => {
		if(setValue){
			if (selectedOrganization !== value) setValue(selectedOrganization)
		}
	}, [selectedOrganization])
	useEffect(() => {
		getOrganizations(user.uid)
			.then((data) => {
				if (data) {
					const organizations = data.map((organization) => {
						return {
							id: organization.id,
							data: organization.data
						}
					})
					dispatch(storeSetOrganizations(organizations));
				}
			})
	}, [])
	return (
		<>
			<div>
				{!hideHome && <div className={`campaign__list-accountsItem ${dropdownDisplayLabel() === 'Home' && 'campaign__list-accountsItemActive'}`} onClick={() => setSelectedOrganization(null)}>
					<div className="campaign__list-accountsItemText">
						<span className="material-icons font--20 vm--align mright--10"> home </span>
						Home
					</div>
				</div>}

				{showOrgsSearch && (
					<div className="campaign__list-accountsSearch" style={{ position: 'relative' }}>
						<label htmlFor="organization-dropdown-search" className="sr-only">Search organizations</label>
						<input
							id="organization-dropdown-search"
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							type="text"
							placeholder="search"
						/>
					</div>
				)}

				{showOrgsSearch && searchTerm && filteredOrganizations.length === 0 && (
					<div className="campaign__list-accountsEmpty">No organizations match your search.</div>
				)}

				{filteredOrganizations.map((organization) => {
					return (
						<div className={`campaign__list-accountsItem ${dropdownDisplayLabel() == organization.data.name && 'campaign__list-accountsItemActive'}`} key={organization.id} onClick={() => setSelectedOrganization(organization)}>
							<div className="campaign__list-accountsItemText">
								<span className="material-icons font--20 vm--align mright--10"> business </span>
								{organization?.data?.name}
								<span className="btn btn-transparent material-icons campaign__list-accountsItemOptions" onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									setOrganizationModal(organization)
								}}>
									settings
								</span>
							</div>
						</div>
					)
				})}
			</div>
			{ organizationModal && <OrganizationSettingsModal closeCb={setOrganizationModal} organization={organizationModal} />}
		</>
	)
}
export default OrganizationsDropdown